<template>
    <div class="bg_white">
        <van-nav-bar
        title="培训报名"
        left-text=""
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
        >
        <template #right>
            <van-icon name="wap-home-o" size="20"/>
        </template>
        </van-nav-bar>

      <van-cell-group>
        <van-cell value="(高危行业)考核合格证申请表" to="/signUp" is-link/>
        <van-cell value="安全培训学员登记表" to="/signUpCy" label="从业人员请选择安全培训登记" is-link/>

        <van-cell value="改证、补证申请表" @click="loadExcel('gzbzsqb.doc')" is-link/>
        <van-cell value="高危行业补证流程" @click="loadExcel('gwhybzlc.doc')" is-link/>
        <van-cell value="领证委托书" @click="loadExcel('lzwts.docx')" is-link/>
      </van-cell-group>
      <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">
        培训须知
      </van-divider>
      <p style="color:red">须将所需材料纸质版提交到协会办公室提交才算报名成功</p>
      <van-collapse v-model="activeNames" title="培训须知">
        <van-collapse-item title="一、（高危行业）考核合格证申请表" name="1">
          <p>高危行业主要负责人、安全生产管理人员（初次申领、复审、延续换证、补证）</p>
          <p>1、危险化学品（包括经营、生产和储存单位）</p>
          <p>2、烟花爆竹经营单位</p>
          <p>3、金属冶炼单位</p>
          <p>4、非煤矿山生产经营单位</p>
        </van-collapse-item>
        <van-collapse-item title="二、安全培训学员登记表" name="2">
          <p>初次培训、再教育培训</p>
          <p>1、危险化学品、烟花爆竹从业人员</p>
          <p>2、其他生产经营单位主要负责人、安全生产管理人员</p>
          <p>3、班组长人员</p>
          <p>4、职业卫生</p>
        </van-collapse-item>
        <van-collapse-item title="新培训需交材料" name="3">
          <p>2寸白底免冠彩照2张</p>
          <p>身份证正反面复印件一张</p>
          <p>初中及以上学历证明复印件一份</p>
          <!-- <p>八闽健康码</p> -->
        </van-collapse-item>
        <van-collapse-item title="复审/再教育续交材料" name="4">
          <p>2寸白底免冠彩照2张</p>
          <p>身份证正反面复印件一张</p>
          <p>原证件及证件培训记录复印件</p>
          <!-- <p>八闽健康码</p> -->
        </van-collapse-item>
      </van-collapse>
    </div>
</template>

<script>
import { getUserInfo } from '../../api/custom';
export default {
  data() {
    return {
      activeNames:["1","2"]
    }

   },
   created(){
    this.getInfo()
   },
   methods: {
    loadExcel (name) {
      //pdf文件地址  测试可用
      // let baseurl = 'http://localhost:8081/api/v1/previewPdf?id='+id
      // let baseurl = 'http://api.fzsyjxh.com/api/v1/downLoadExcel?name='+name
      let baseurl = 'http://api.fzsyjxh.com/api/v1/downLoadExcel?name='+name
      //根据实际情况 通过相对路径找到viewer.html
      window.open(baseurl);
    },
    downExcel(){
      window.location.href=this.common.getImageUrl('public/改证、补证申请表.doc')
    },
    getInfo(){
        getUserInfo().then(res=>{
            this.userInfo=res.data.info
        })
    },
    onClickLeft() {
      this.$router.back()
    },
    onClickRight() {
      this.$router.push("/home")
    },
  }

};
</script>

<style lang="less">
p{
  padding: 0 15px;
}


</style>

